// extracted by mini-css-extract-plugin
export default {"page":"_404_page__9UkKo","not-found":"_404_not-found__4-jxC"};